module.exports = __webpack_public_path__ + "static/media/icon-rocket.b3332614.svg";